import { ErrorService } from "services/error-service";
import { Router } from "aurelia-router";
import { Models } from "models/core";
import { DimensionClassService } from "services/dimension-class-service";
import { autoinject } from "aurelia-framework";
import { ToastService } from "services/toast-service";
import { EventAggregator } from "aurelia-event-aggregator";

@autoinject
export class DimensionClassNew {
  private dimensionclass: Models.DimensionClass = new Models.DimensionClass();

  constructor(
    private dimensionClassService: DimensionClassService,
    private router: Router,
    private toastService: ToastService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator
  ) {}

  createDimensionClass() {
    this.dimensionClassService
      .post(this.dimensionclass)
      .then(res => {
        this.eventAggregator.publish("dimensionClassListReset", 1);
        this.toastService.showSuccess("dimensionclass.created");
        this.router.navigateToRoute("dimension-class-detail", { Id: res.Id });
      })
      .catch(err => this.errorService.handleError(err));
  }
}
